import { mapState } from 'vuex';

export default () => ({
    computed: {
        ...mapState({
            userInfoStore: (state) => state.user_info_store.userInfo,
        }),
    },
    methods: {
        cancelSubscriptionClick(callback) {
            const MOBILE_PAYMENT_METHODS = ['play_store', 'app_store'];
            const isMobilePayment = this.userInfoStore.subscription.source === 'revenuecat'
                && MOBILE_PAYMENT_METHODS.includes(this.userInfoStore.subscription.paymentMethod);
            if (isMobilePayment) {
                window.open('https://support.voicemod.net/hc/en-us/articles/360018188920-How-to-cancel-the-renewal-of-my-subscription#h_01JTNGC7Q3WH6YF2C2SZKTJ1RB', '_blank');
                return;
            }

            callback();
        },
    },
});
